import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { PagesComponent } from './pages.component';
import { AboutComponent } from './about/about.component';
import { AuthGuard } from '../../providers/auth-guard.service';
import { AuthService } from '../../providers/auth.service'
import { LotteryResolver } from "./lottery/lottery.resolver";

export const routes: Routes = [
    { path: 'domains', loadChildren: 'app/domains#DomainsModule' },
    { path: 'explorer', loadChildren: 'app/explorer#ExplorerModule' },
    { path: 'mobilepc', loadChildren: 'app/mobilepc#MobilepcModule' },
    { path: 'login', loadChildren: 'app/login#LoginModule' },
    { path: 'daike/:Key', loadChildren: 'app/pages/daike#DaiKeModule' },
    { path: 'chat/:Key', loadChildren: 'app/pages/chat-message#ChatMessageModule' },
    { path: 'register', loadChildren: 'app/regist#RegistModule' },
    { path: 'weblogin', canActivate: [AuthGuard], loadChildren: 'app/weblogin#WebLoginModule' },
    { path: 'mobile', canActivate: [AuthGuard], loadChildren: 'app/mobile#MobileModule' },
    { path: 'lottery-trend/:lotteryCode', canActivate: [AuthGuard], loadChildren: 'app/lottery-trend#LotteryTrendModule', resolve: { lottery: LotteryResolver } },
    { path: 'lottery-longhu/:lotteryCode', loadChildren: 'app/lottery-longhu#LotteryLonghuModule', resolve: { lottery: LotteryResolver } },
    { path: 'test-signalr', loadChildren: 'app/testsignalr#TestSignalrModule' },
    { path: 'maintain', loadChildren: 'app/maintain#MaintainModule' },
    {
        path: 'app', component: PagesComponent, canActivate: [AuthGuard], children: [
            { path: '', redirectTo: 'index', pathMatch: 'full' },
            { path: 'index', loadChildren: 'app/pages/indexpage#IndexpageModule' },
            { path: 'lottery', loadChildren: 'app/pages/lottery#LotteryModule' },
            { path: 'lottery-trend/:lotteryCode', loadChildren: 'app/lottery-trend#LotteryTrendModule', resolve: { lottery: LotteryResolver } },
            { path: 'activity', loadChildren: 'app/pages/activity#ActivityModule' },
            { path: 'notice/:id', loadChildren: 'app/pages/notice#NoticeModule' },
            { path: 'download', loadChildren: 'app/pages/download#DownloadModule' },
            { path: 'help-center', loadChildren: 'app/pages/help-center#HelpCenterModule' },
            { path: 'manager', loadChildren: 'app/pages/manager#ManagerModule' },
            { path: 'xbbrand', loadChildren: 'app/pages/xbbrand#XbbrandModule' },
            { path: 'ag', loadChildren: 'app/pages/ag#VrFunModule' },
            { path: 'gamma', loadChildren: 'app/pages/gamma#GammaModule' },
            { path: 'shaba', loadChildren: 'app/pages/shaba#ShaBaModule' },
            { path: 'ebet', loadChildren: 'app/pages/ebet#EbetModule' },
            { path: 'ky', loadChildren: 'app/pages/kaiyuan#KaiYuanModule' },
            { path: 'yg', loadChildren: 'app/pages/yg#YgModule' },
            { path: 'yabo', loadChildren: 'app/pages/yabo#YaBoModule' },
            { path: 'yabo-live', loadChildren: 'app/pages/yabo-live#YaBoLiveModule' },
            { path: 'imdj', loadChildren: 'app/pages/imdj#ImdjModule' },
            { path: 'im2', loadChildren: 'app/pages/im#ImModule'},
            { path: 'ob', loadChildren: 'app/pages/ob#ObModule'},
            { path: 'cr', loadChildren: 'app/pages/cr#CrModule'},
            { path: 'pg', loadChildren: 'app/pages/pg#PgModule'},
            { path: 'pmreal', loadChildren: 'app/pages/pm#PmModule'},
            { path: 'bg', loadChildren: 'app/pages/bg#BgModule'},
            { path: 'yaxing', loadChildren: 'app/pages/yx#YaXingModule'},
            { path: 'kaixuan', loadChildren: 'app/pages/kaixuan#KaiXuanModule'},
            { path: 'bs', loadChildren: 'app/pages/baisheng#BaiShengModule'},
            { path: 'oubo', loadChildren: 'app/pages/oubo#OuBoModule'},
            { path: 'third/:code', loadChildren: 'app/pages/third#ThirdModule'},
            { path: 'wechat-promotion', loadChildren: 'app/pages/service-center/wechat-promotion#WechatPromotionModule' },
            { path: 'automatic-injection', loadChildren: 'app/pages/service-center/automatic-injection#AutomaticInjectionModule' },
            { path: 'domain-name', loadChildren: 'app/pages/service-center/domain-name#DomainnameModule' },
            { path: 'google-password', loadChildren: 'app/pages/service-center/google-password#GooglePasswordModule' },
            { path: 'lottery-longhu/:lotteryCode', loadChildren: 'app/lottery-longhu#LotteryLonghuModule', resolve: { lottery: LotteryResolver } },


        ]
    },

];

export const appRoutingProviders: any[] = [
    AuthGuard
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false });



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/pages/pages.routes.ts